var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCNews = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  className: "c-news_svg__icon c-news_svg__icon-tabler c-news_svg__icon-tabler-news",
  width: 24,
  height: 24,
  strokeWidth: 1.5,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z",
  stroke: "none"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M16 6h3a1 1 0 0 1 1 1v11a2 2 0 0 1-4 0V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v12a3 3 0 0 0 3 3h11M8 8h4M8 12h4M8 16h4"
})));
export default SvgCNews;